(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("itowns", [], factory);
	else if(typeof exports === 'object')
		exports["itowns"] = factory();
	else
		root["itowns"] = factory();
})(window, function() {
return 